import Seo from '../_Seo'
import LazyMap from '../stations/_LazyMap'
// Defines --go-map-h. Imported HERE rather than in ExploreMap, because
// ExploreMap is lazy: the wrapper below needs its height on the first paint,
// before the map chunk has been fetched. Go Mode fills the WHOLE viewport
// rather than a viewport-minus-header, because ruling 3 takes the header away.
import './_goLayout.css'

// GO MODE — plan "Web map surfaces" section 2.3, rulings 1 and 2.
//
// Not a fourth map surface: the SAME ExploreMap the home page and /explore
// render, composed for a reader who is on the water. Depth Chart where the
// chart covers them, nothing moving, location follow on, no picker, no
// timeline, bigger buttons, one way out. `goMode` is the only prop that says
// so; every rule it implies lives in _goMode.js and in ExploreMap's own
// composition, not here.
//
// THE ENTRY VIEW COMES FROM THE HASH (`#zoom/lat/lng`), which is what makes the
// Go button on any other surface a plain link that carries the reader's current
// view. The layer token in it is IGNORED — Go Mode chooses its own ground from
// coverage — as is the player token, because there is no player to open.
//
// `noindex`: this is an instrument, not a page. It has no content of its own,
// its URL is a view rather than a place, and a search result landing here would
// be a reader dropped into boat mode by accident.
export default function Go({ layer_coverage: layerCoverage = null }) {
  return (
    <>
      <Seo
        title="Go"
        description="The live tide and current map, following your location."
        noindex
      />
      <div style={{ position: 'relative', width: '100%', height: 'var(--go-map-h)' }}>
        <LazyMap
          load={() => import('../explore/ExploreMap')}
          surface="go"
          height="var(--go-map-h)"
          // The map IS the page, and the reader pressed Go to be shown where
          // they are, so the ask is spent here on arrival — the same rule
          // /explore follows (see _askPolicy). Refusing it leaves Go Mode open
          // at the hash view with follow off and says nothing more than the
          // existing location-denied state already says.
          askLocation="load"
          goMode
          layerCoverage={layerCoverage}
        />
      </div>
    </>
  )
}
